import { Route, Routes } from 'react-router-dom'

import type { ReactElement } from 'react'

import CompareCohorts from '.'
import { CompareCohortsContextProvider } from '~/providers/CompareCohorts'

const CompareCohortsRouter = (): ReactElement => {
  return (
    <CompareCohortsContextProvider>
      <Routes>
        <Route element={<CompareCohorts />} path="*" />
      </Routes>
    </CompareCohortsContextProvider>
  )
}

export default CompareCohortsRouter
